
export default {
  data() {
    return {
      mydj: {
        ytj: {},
        spz: {},
        djs: {}
      },
      dsp: {
        cgdsp: {},
        otherDsp: {},
        saleDsp: {}
      },
      dfk: {
        cgDfk: {},
        otherDFk: {}
      },
      yfk: {
        day: {},
        week: {},
        month: {},
        year: {}
      },
      arrlistall: [0, 0, 0, 0, 0],
      arrlistDY: [0, 0, 0, 0, 0],
      userName: localStorage.getItem('userName'),
      userNo: localStorage.getItem('userNo'),
      echartsData: {},
      ydata: [],
      ydatas: [],
      jump: {
        temp: [],
        params: {}
      }

    }
  },
  created() {
    this.fnResize()
    this.queryMianIndex()
    this.menuTreeToArrs(this.$store.state.menuState.menu, this.jump.temp)
  },
  mounted() {
    this.initEcharts()
    //监听窗口变化以改变字体大小
    window.addEventListener('resize', () => {
      this.fnResize()
    })
  },
  methods: {
    fnResize() {
      var deviceWidth = document.documentElement.clientWidth || window.innerWidth
      if (deviceWidth >= 1536) {
        deviceWidth = 1536
      }
      if (deviceWidth <= 320) {
        deviceWidth = 320
      }
      document.documentElement.style.fontSize = (deviceWidth / 15.36) + 'px'
    },
    openNewPage(name, status) {
      if (status) {
        this.jump.params = { status }
      }
      const menus = this.jump.temp.filter(item => item.menuName === name)
      if (menus.length > 0) {
        const menu = menus[0]
        const activePath = menu.path
        var tabList = this.$store.getters.getTabList
        var result = tabList.some(item => {
          if (item.name === activePath) {
            return true
          }
        })

        // 如果不包含该对象，则添加
        if (!result) {
          this.$store.commit('add_tags', {
            path: activePath,
            name: activePath,
            label: menu.menuName
          })
        }

        // 菜单链接值
        this.$store.commit('set_ActivePath', activePath)
        this.$router.push({ name: activePath, params: this.jump.params })
      }
    },
    menuTreeToArrs(menus, temp) {
      menus.forEach(menu => {
        temp.push(menu)
        if (menu.children && menu.children.length > 0) {
          this.menuTreeToArrs(menu.children, temp)
        }
      })
    },
    queryMianIndex() {
      const data = {
        lrr: localStorage.getItem('userName'),
        lrrCode: localStorage.getItem('userNo')
      }
      this.$post('/fesback/HomePage/indexDates.z', data).then(request => {
        this.arrlistall = [request.cg, request.xs, request.sb, request.jx, request.sk]
        this.arrlistDY = [request.dycg, request.dyxs, request.dysb, request.dyjx, request.dysk]
        this.mydj.ytj.count = request.MyDjYtjCount
        this.mydj.ytj.je = this.formatAmount((request.MyDjYtjJe / 10000).toFixed(2))
        this.mydj.spz.count = request.MyDjSpzCount
        this.mydj.spz.je = this.formatAmount((request.MyDjSpzJe / 10000).toFixed(2))
        this.mydj.djs.count = (parseFloat(request.MyDjDjsCount + request.MyDjCgDfkCount).toFixed(0))
        this.mydj.djs.je = this.formatAmount(((parseFloat(request.MyDjDjsJe + request.MyDjCgDfkJe)) / 10000).toFixed(2))
        this.dfk.cgDfk.count = request.CgDfkDjCount
        this.dfk.cgDfk.je = this.formatAmount((request.CgDfkDjJe / 10000).toFixed(2))
        this.dfk.otherDFk.count = request.OrtherDfkDjCount
        this.dfk.otherDFk.je = this.formatAmount((request.OrtherDfkDjJe / 10000).toFixed(2))
        this.yfk.day.je = this.formatAmount((request.YfkDjDayJe / 10000).toFixed(2))
        this.yfk.month.je = this.formatAmount((request.YfkDjMonthJe / 10000).toFixed(2))
        this.yfk.week.je = this.formatAmount((request.YfkDjWeekJe / 10000).toFixed(2))
        this.yfk.year.je = this.formatAmount((request.YfkDjYearJe / 10000).toFixed(2))
        this.dsp.cgdsp.count = request.DspCgCount
        this.dsp.cgdsp.je = this.formatAmount((request.DspCgJe / 10000).toFixed(2))
        this.dsp.otherDsp.count = request.DspOtherCount
        this.dsp.otherDsp.je = this.formatAmount((request.DspOtherJe / 10000).toFixed(2))
        this.dsp.saleDsp.count = request.DspSaleCount
        this.dsp.saleDsp.je = this.formatAmount((request.DspSaleJe / 10000).toFixed(2))
      })
      this.$post('/fesback/HomePage/indexEchartsPaid.z').then(res => {
        for (let i = 0; i < res.length; i++) {
          this.ydatas.push(res[i].data)
        }
        this.initEcharts()
      })
      this.$post('/fesback/HomePage/indexEchartsApply.z').then(res => {
        for (let i = 0; i < res.length; i++) {
          this.ydata.push(res[i].data)
        }
        this.initEcharts()
      })
    },
    formatAmount(value) {
      //传入值不是数字直接返回0
      if (!value) return '0.00'
      const values = value.toString().split('.')
      // 整数部分
      let integerNum = values[0]
      // 小数部分
      let decimalNum = values[1] ? values[1] : '00'
      decimalNum = decimalNum.length === 1 ? decimalNum + 0 : decimalNum
      //传入值小于1000不切割
      if (integerNum < 1000) {
        return `${integerNum}.${decimalNum}`
      }
      const list = []
      while (integerNum.length > 3) {
        // 倒序切割
        list.unshift(integerNum.slice(-3))
        integerNum = integerNum.slice(0, -3)
      }
      // 处理剩余长度
      list.unshift(integerNum)
      return `${list.join(',')}.${decimalNum}`
    },
    initEcharts() {
      // 基本柱状图
      const chart = this.$refs.myChart
      if (chart) {
        const myChart = this.$echarts.init(chart)
        const optionRecords = {
          // color: ['#3f35b6', '#4DE58A'],
          title: {
            text: '费用总和统计',
            left: 'left',
            padding: [10, 0, 0, 20],
            textStyle: {
              fontSize: '14',
              fontWeight: 'normal'
            }
          },
          legend: {
            data: ['申请费用', '已付款费用'],
            x: 'right',
            padding: [10, 100, 0, 0]
          },
          xAxis: {
            data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              formatter: function(v) {
                return v / 10000 + '万'
              }
            }
          },
          series: [
            {
              name: '申请费用',
              type: 'bar',
              data: this.ydata,
              itemStyle: {
                normal: {
                  label: {
                    formatter: function(v) {
                      if (v.data === 0) {
                        return '0'
                      }
                      return (v.data / 10000).toFixed(2)
                    },
                    show: true,
                    position: 'top'
                  }
                }
              }
            },
            {
              name: '已付款费用',
              type: 'bar',
              data: this.ydatas,
              itemStyle: {
                normal: {
                  label: {
                    formatter: function(v) {
                      if (v.data === 0) {
                        return '0'
                      }
                      return (v.data / 10000).toFixed(2)
                    },
                    show: true,
                    position: 'top'
                  }
                }
              }
            }
          ],
          grid: { // 让图表占满容器
            top: '60px',
            left: '60px',
            right: '10px',
            bottom: '40px'
          }
        }
        myChart.setOption(optionRecords)
        // echarts 窗口缩放自适应
        window.onresize = () => {
          myChart.resize()
        }
      }
    }
  }
}
